import { render } from "./CompaniesOverview.vue?vue&type=template&id=92f04912&ts=true"
import script from "./CompaniesOverview.vue?vue&type=script&lang=ts"
export * from "./CompaniesOverview.vue?vue&type=script&lang=ts"

import "./CompaniesOverview.vue?vue&type=style&index=0&id=92f04912&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__